export default (id, contacts) => {
  const rs = contacts.find(contact => contact.id && contact.id === id);
  if (rs) return rs.user.fullNameWithTitle;
  return rs;
};
